import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import UbiContents from '@di-shared/features/ubi/UbiContents';
import UbiContentsError from '@di-shared/features/ubi/UbiContentsError';
import UbiContentsLoading from '@di-shared/features/ubi/UbiContentsLoading';

export interface UbiPageProps {
  vin: string;
}

function UbiPage({vin}: UbiPageProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1
          className="title_xsmall_b nav_center_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T20019')}
        </h1>
      </Header>
      <ErrorBoundary fallback={<UbiContentsError />}>
        <Suspense fallback={<UbiContentsLoading />}>
          <UbiContents vin={vin} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default UbiPage;
